"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesNamesWithReplayAbility = void 0;
var servicesNamesWithReplayAbility;
(function (servicesNamesWithReplayAbility) {
    servicesNamesWithReplayAbility["CC_QUEUE"] = "cc-queue";
    servicesNamesWithReplayAbility["EVENT_SINK"] = "event-sink";
    servicesNamesWithReplayAbility["FLOW_MANAGER"] = "flow-manager";
    servicesNamesWithReplayAbility["IMPORT"] = "import";
    servicesNamesWithReplayAbility["ONBOARDING"] = "onboarding";
    servicesNamesWithReplayAbility["OUTREACH"] = "outreach";
    servicesNamesWithReplayAbility["PARTNER"] = "partner";
    servicesNamesWithReplayAbility["PATIENT"] = "patient";
    servicesNamesWithReplayAbility["PRESCRIPTION"] = "prescription";
    servicesNamesWithReplayAbility["SCHEDULER"] = "scheduler";
    servicesNamesWithReplayAbility["NOTIFICATIONS_WORKER"] = "notifications-worker";
    servicesNamesWithReplayAbility["SFTP_WORKER"] = "sftp-worker";
    servicesNamesWithReplayAbility["SEND_RESULTS"] = "send-results";
    servicesNamesWithReplayAbility["KIT_LIFECYCLE"] = "kit-lifecycle";
})(servicesNamesWithReplayAbility || (exports.servicesNamesWithReplayAbility = servicesNamesWithReplayAbility = {}));
